<template>
  <div class="item-bundle">
        <div class="item-bundle__basic">
          <div class="item-bundle__select">
            <span>
              <v-checkbox
              v-model="selected"
              color="#1b99a7"
              hide-details
              @change="changeSelected"
            ></v-checkbox>

            </span>
            
          </div>
          <div class="item-bundle__avatar">
            <v-img
            :src="image" :alt="model.name"
            :lazy-src="image"
              contain
              max-width="50px"
              height="32"
            >
            <template v-slot:placeholder>
              <v-row
                class="fill-height ma-0"
                align="center"
                justify="center"
              >
              <div style="width: 100%; height: 100%; display: block; background-color: #e2e2e2;"></div>
              </v-row>
            </template>
          </v-img>
          </div>
          <div class="item-bundle__name">{{ model.name }}</div>
        </div>
        <div class="item-bundle__additional">
          <div class="item-bundle__level"><SimpleChip auto-width :value="model.level" :name="model.level" small default-icon="" readonly></SimpleChip>
    </div>
          <div class="item-bundle__pack-unit"><strong>{{ $t('PACK-UNIT-ARTICLE-NO') }}:</strong>&nbsp;{{ model.articleNo }}</div> 
          <div class="item-bundle__gtin">
            <ItemGtins :gtins="model.gtins" />
          </div>
          <div class="item-bundle__status">
              <SimpleChip readonly small short center defaultIcon="" readonlyColor="#51ad5f" v-if="model.status === 'complete'" :value="model.status" :name="$t('ARTICLE-BUNDLE-STATUS-COMPLETE')" />
              <SimpleChip readonly small  short center defaultIcon="" readonlyColor="#adadad" v-else :value="model.status" :name="$t('ARTICLE-BUNDLE-STATUS-INCOMPLETE')" />
          </div>
          <div class="item-bundle__action">
            <v-btn plain elevation="0" @click="redirectToPropertiesUnit">
              <v-icon>mdi-arrow-right-bold-outline</v-icon>
            </v-btn>
          </div>
        </div>
          
      </div>
</template>

<script>
import {cloneDeep} from 'lodash';
import SimpleChip from '../../components/ui-elements/SimpleChip.vue';
import ItemGtins from '@/components/item/ItemGtins.vue';
  export default {
    name: 'ItemBundle',
    props: {
      bundle: {
        type: Object,
      },
    },
    components: {SimpleChip, ItemGtins},
    data(){
      return {
        model: null,
        selected: false,
      };
    },
    created(){
        this.init();
    },
    computed: {
      image(){
        if(!this.model || !this.model.bundletype || !this.model.bundletype.image) return "";
        return `${this.$config.cdn}${this.model.bundletype.image}`;
      },
      selectedBundles(){
        return this.$store.getters['selectedBundles'];
      },
    },
    watch:{
      selectedBundles:{
        handler(bundles){
          if(!bundles || !bundles.length){
            this.selected = false;
          }else{
            const isSelected = bundles.find((item) => item.id === this.model.id);
            this.selected = !!isSelected;
          }
        },
        deep: true
      }
    },
    methods:{
      changeSelected(value){
        if(!value){
          this.unselectBundle();
        }else{
          this.selectBundle();
        }
      },
      unselectBundle(){
        this.$store.commit('UNSELECT_BUNDLE', cloneDeep(this.model));
      },
      selectBundle(){
        this.$store.commit('SELECT_BUNDLE', cloneDeep(this.model));
      },
      init(){
        this.model = cloneDeep(this.bundle);
      },
      redirectToPropertiesUnit(){
        if(!this.model || !this.model.id) throw Error('Missing required id');
        this.$store.commit('SET_SHOW_ARTICLE_PROPERITES_UNIT', this.model.id);
        this.$emit('redirectToItem');
      }
    }
  }
</script>

<style lang="scss" scoped>
  .item-bundle{
    display: flex;
    width: 100%;
    color: #666666 !important;
    font-family: Arial, sans-serif!important;
    font-weight: 400!important;
    font-size: 14px!important;
    line-height: 16.1px!important;

    &__basic{
      flex: 1;
      display: flex;
      flex-wrap: wrap;
    }

    &__additional{
      flex: 3;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
    }

    &__select{
      flex: 0 1 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      & > *::v-deep .v-input--selection-controls{
        margin-top: auto;
        padding-top: 0;
      }
      & > *::v-deep .v-application--is-ltr .v-input--selection-controls__input{
        margin-right: 0;
      }
    }

    &__avatar{
      flex: 0 1 60px;
    }

    &__name{
      flex: 1;
      display: flex;
      align-items: center;
    }

    &__level{
      flex: 0 1 120px;

      display: flex;
      align-items: center;
    }

    &__pack-unit{
      flex: 1;
      padding-right: 6px;
      display: flex;
      align-items: center;
    }

    &__gtin{
      flex: 1;

      display: flex;
      align-items: center;

    }
    
    &__status{
      flex: 1;
      display: flex;
      align-items: center;

    }

    &__action{
      flex: 0 1 50px;

      display: flex;
      justify-content: flex-end;
      padding-right: 12px;
      align-items: center;
    }

  }
</style>
